import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import type { ConfigKey } from '@/types';

import { API_ROUTES } from '@/query/routes';
import axiosInstance from '@/utils/api/axios-instance';

interface UpdateMapConfigPayload {
  key: ConfigKey;
  value: boolean;
}

const useUpdateMapConfig = (
  options?: UseMutationOptions<Record<ConfigKey, boolean>, Error, UpdateMapConfigPayload>
) => {
  return useMutation({
    mutationFn: async ({ key, value }) => {
      const partialConfig = { [key]: value };

      const response = await axiosInstance.patch(API_ROUTES.mapConfig, {
        mapConfig: partialConfig,
      });

      return response.data;
    },
    ...options,
  });
};

export default useUpdateMapConfig;
